import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getOverseaAgentUserList(params) {
  return request({
    url: URL.partner.overseaAgentUser,
    method: 'get',
    params
  })
}

export function saveOverseaAgentUser(data) {
  return request({
    url: URL.partner.overseaAgentUser,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delOverseaAgentUser(uuid) {
  return request({
    url: URL.partner.overseaAgentUser + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
